<div class="grid ">
    <div class="col-12">
        <div class="card" *ngIf="!verificarPermissao('PERM_INSERIR_CONFIGURACAO_ANAMNESE')">
            <div style="text-align: center;">
                <h4>Você não possui permissão de acesso essa página!</h4>
            </div>
        </div>
        <div class="card" *ngIf="verificarPermissao('PERM_INSERIR_CONFIGURACAO_ANAMNESE')">
                <form 
                 #f="ngForm" name="form" novalidate>
                    <div class="formgroup">
                        <div *ngIf="messagemVisivel" class="w-full mb-5">
                            <p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
                        </div>
                        <div class="p-fluid p-formgrid grid">
                                <div class="field col-12 md:col-10">
                                    <label htmlFor="descricao">Descrição</label>
                                    <input name="descricao" type="text" pInputText placeholder="Digite a descrição"
                                        ngModel
                                        #descricao="ngModel" required />
                                    <div *ngIf="descricao.hasError('required') && descricao.dirty">
                                        <small>Campo obrigatório</small>
                                    </div>
                                </div>
                                <div class="field col-12 md:col-2">
                                    <label for="lgpd">
                                        LGPD
                                    </label>
                                    <br />
                                    <p-inputSwitch name="lgpd" [(ngModel)]="valorLgpd">
                                    </p-inputSwitch>
                                </div>
                        </div>
                            <div class="p-fluid p-formgrid grid justify-content-between">
                                <div class="col-12 md:col-4">
                                    <button *ngIf="!progressoRequisicao else exibirBotaoFalso" type="submit" pButton icon="pi pi-check" label="Salvar"
                                        class="p-button-outlined p-button-success md:w-9rem" [disabled]="!f.valid" (click)="salvar()">
                                    </button>
                                    <ng-template #exibirBotaoFalso>
                                        <button type="submit" pButton icon="pi pi-spin pi-spinner"
                                        label="Salvar" class="p-button-outlined p-button-success md:w-9rem" disabled>
                                       </button>
                                    </ng-template>
                                </div>
                                <div class="col-12 md:col-4 flex justify-content-end">
                                    <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                        class="p-button-outlined md:w-9rem" routerLink="/apps/anamnese-configuracao">
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
        </div>
    </div>
    